module.exports = __webpack_public_path__ + "static/media/dao.96a6c46a.png";